<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li :class="tabIndex == 0 ? 'active' : ''" @click="clickTab(0)">
          有效课程({{ validCount }})
        </li>
        <li :class="tabIndex == 1 ? 'active' : ''" @click="clickTab(1)">
          已学课程({{ invalidCount }})
        </li>
      </ul>
      <div class="course-search">
        <Input
          search
          v-model="searchKeywords"
          @on-search="searchCourse"
          placeholder="请输入课程名称或代码"
        />
      </div>
    </div>

    <div class="member-main-body">
      <div class="no-data" v-show="courseList.length == 0">
        <img src="../../assets/images/v3/no-data.png" />
        <p v-if="tabIndex == 0">您还没有课程，赶紧去购买吧</p>
        <p v-else>您还没有已学课程</p>
        <Button
          v-if="tabIndex == 0"
          type="primary"
          shape="circle"
          style="width: 100px; margin-top: 10px"
          :to="{ name: 'ProductList' }"
          >选购课程</Button
        >
      </div>
      <ul class="course-list">
        <li v-for="(item, index) in courseList" :key="index">
          <div class="course-name">
            「{{ item.courseNo }}」{{ item.courseName }}
          </div>
          <div class="course-btn">
            <!-- <router-link
              v-if="!item.umcOverdue"
              :to="{ name: 'CourseStudy', params: { cid: item.courseId } }"
              target="_blank"
              title="开始学习"
            > -->
            <Button
              v-if="!item.umcOverdue"
              type="primary"
              long
              shape="circle"
              @click="goLearn(item)"
              >开始学习</Button
            >
            <!-- @click="goLearn(item)" -->

            <!-- </router-link> -->
            <router-link
              v-else
              :to="{ name: 'CourseDetail', params: { id: item.productId } }"
              target="_blank"
              title="我要续费"
            >
              <Button type="primary" long shape="circle">我要续费</Button>
            </router-link>
          </div>
        </li>
      </ul>
    </div>

    <Modal
      v-for="(item, index) in messageList"
      :key="index"
      v-model="item.visible"
      :closable="false"
      :mask-closable="true"
      @on-cancel="setAllReaded"
      width="460"
    >
      <p style="padding: 20px 0; font-size: 1.6rem">{{ item.content }}</p>
      <div slot="footer">
        <Button
          type="success"
          @click="viewCourse(item)"
          style="margin-right: 20px"
          >去看看</Button
        >
        <Button type="primary" @click="nextNotice(item, index)">{{
          index + 1 == messageList.length ? '知道了' : '下一条'
        }}</Button>
      </div>
    </Modal>

    <Modal
      :title="null"
      v-model="isShowSigningCode"
      ok-text="我已签约完成"
      cancel-text=""
      width="320"
      class-name="vertical-center-modal"
      :mask-closable="false"
      @on-ok="confirmSigning"
    >
      <div class="code">
        <vue-qr
          :margin="5"
          :size="180"
          :correctLevel="3"
          :text="qrcodeData.url"
          :logoSrc="qrcodeData.icon"
          :logoMargin="5"
          style="display: block; margin: 24px auto"
        ></vue-qr>
      </div>
      <div class="tips" style="text-align: center; color: #258aff">
        请扫码完成签约
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import { user, order } from '../../request';
import { getToken } from '../../utils/localStorage';
import VueQr from 'vue-qr';
import { toUSVString } from 'util';
export default {
  mixins: [siteMixin],
  components: {
    VueQr,
  },
  data() {
    return {
      tabIndex: 0,
      messageList: [],
      searchKeywords: '',
      isShowSigningCode: false, //是否显示签约协议二维码
      qrcodeData: {
        url: '',
        icon: '',
      },
      agreementIndex: 0,
      agreementFinish: false,
    };
  },
  computed: {
    //课程数量
    validCount() {
      return this.userCourseList.filter((item) => !item.umcOverdue).length;
    },
    invalidCount() {
      return this.userCourseList.filter((item) => item.umcOverdue).length;
    },
    courseList() {
      if (this.tabIndex == 0) {
        return this.userCourseList.filter((item) => !item.umcOverdue);
      } else {
        return this.userCourseList.filter((item) => item.umcOverdue);
      }
    },
  },
  beforeMount() {
    //如果是定制机的话，跳转走
    if (this.$customIds.includes(this.siteConfig.agencyId)) {
      this.$router.push({ name: 'StudyPlan' });
    }
  },
  mounted() {
    this.setMetaData('我的课程');
    this.getMessage();
  },
  methods: {
    getMessage() {
      user.getMessageWithCourse(0, this.loginUser.userId, -1).then((res) => {
        //console.log("messageB", res);
        if (res.status === 1) {
          this.messageList = res.data.slice(0, 10);
          this.messageList.forEach((item, index) => {
            if (index === 0) {
              this.$set(item, 'visible', true);
            } else {
              this.$set(item, 'visible', false);
            }
          });
        }
      });
    },
    viewCourse(item) {
      this.setReated(item.uCID, () => {
        this.$router.push({
          name: 'CourseStudy',
          params: { cid: item.courseId },
        });
      });
    },
    nextNotice(item, index) {
      this.setReated(item.uCID, () => {
        item.visible = false;
        if (this.messageList.length <= index + 1) return;
        this.messageList[index + 1].visible = true;
      });
    },
    setReated(id, callback) {
      user.setMessageReaded(id, 2).then((res) => {
        if (callback) callback();
      });
    },
    setAllReaded() {
      user.setMessageReaded(0, 2, this.loginUser.userId).then((res) => {
        //。。。
        console.log('设置完成');
      });
    },
    searchCourse() {
      this.getUserCourseList();
    },
    //获取数据
    getUserCourseList() {
      user
        .getUserCourseList(this.loginUser.userId, this.searchKeywords)
        .then((res) => {
          //console.log("userCourse", res);
          if (res.status == 1) {
            this.setUserCourseList(res.data);
          } else {
            this.$Message.error(res.message);
          }
        });
    },
    // 切换tab
    clickTab(index) {
      if (this.tabIndex == index) return false;
      this.tabIndex = index;
    },

    // 前往学习
    async goLearn(item) {
      const { data } = await user.getAgreementCheckByCourse({
        umcId: item.umcIdList[this.agreementIndex],
      });
      this.handleAgreementItem = item;
      this.agreementObj = data;
      if (data.check === 1) {
        const authToken = getToken();
        this.isShowSigningCode = true;
        this.qrcodeData.url = `http://${this.siteConfig.mdomain}/me/signingDetail?id=${data.agreementId}&orderId=${data.orderId}&source=pc&userId=${this.loginUser.userId}&token=${authToken.nextAuth}`;
        return;
      }

      //签约
      if (this.nextCheckAgreement(1)) return;

      if (data.check === 2) {
        this.$Modal.info({
          title: '提示',
          content: '您己提交签约协议，等待协议通过即可开始学习',
          okText: '知道了',
          onOk: () => {},
        });
        return;
      }

      //审核通过，到一个
      if (this.nextCheckAgreement(2)) return;

      const url = `/topic/course/study/${item.courseId}`;
      window.open(url, '_blank');
    },
    // 已签约完成
    async confirmSigning() {
      // getIsCheckAgreement
      const { agreementId, orderId } = this.agreementObj;
      const { data } = await order.getIsCheckAgreement({
        agreementId,
        orderId,
        type: 2,
        userId: this.loginUser.userId,
      });
      if (data.status === 1) {
        this.goLearn(this.handleAgreementItem);
      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '签约未完成，请重新签约',
          okText: '重新签约',
          cancelText: '取消',
          onOk: () => {
            this.isShowSigningCode = true;
          },
        });
      }
    },
    nextCheckAgreement(type) {
      //上一个已经签或已审核完成，继续下一个
      if (type === 1 && this.agreementFinish) return false;
      const length = this.handleAgreementItem.umcIdList.length;
      if (length && this.agreementIndex < length - 1) {
        this.agreementIndex++;
        this.goLearn(this.handleAgreementItem);
        return true;
      } else {
        this.agreementFinish = true;
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var.less';
@import '../../assets/css/member-main.less';
.course-search {
  margin: 14px 30px 0 0;
  /deep/.ivu-input {
    background: #f2f2f2;
    border-radius: 20px;
    padding-left: 12px;
  }
}
.course-list {
  padding: 20px 30px;
  li {
    border-bottom: 1px dashed #ccc;
    display: flex;
    align-items: center;
    padding: 10px 0;
    .course-name {
      flex: 1;
      font-size: 16px;
    }
    .course-btn {
      width: 100px;
    }
  }
}
</style>
